module.exports = __webpack_public_path__ + "static/media/bootcamper network.0964e489.png";